import { Entity } from "@models/Entity";
import { registerFeatureErrorMapper } from "@lib/errors";
import { productErrorMapper } from "@features/products/errors";
import { customerErrorMapper } from "@features/customers/errors";
import { locationErrorMapper } from "@features/locations/errors";
import { orderErrorMapper } from "@features/orders/errors";
import { billingErrorMapper } from "@features/billing/errors";
import { imageErrorMapper } from "@errors/imageErrors";

/**
 * App composition root for error mappers: wires each feature's mapper into the
 * feature-agnostic error infra (`@lib/errors`). This is the one place allowed to
 * depend on features — so `lib/` never does. Call once during bootstrap.
 */
export function registerFeatureErrors(): void {
  registerFeatureErrorMapper(Entity.PRODUCTS, productErrorMapper);
  registerFeatureErrorMapper(Entity.CUSTOMERS, customerErrorMapper);
  registerFeatureErrorMapper(Entity.LOCATIONS, locationErrorMapper);
  registerFeatureErrorMapper(Entity.ORDERS, orderErrorMapper);
  registerFeatureErrorMapper(Entity.BILLING, billingErrorMapper);
  registerFeatureErrorMapper(Entity.IMAGES, imageErrorMapper);
}
